export const CART_NOT_RESTORED_KEY = 'veer-theme-cart-not-restored';
export const ORIGINAL_CART_KEY = 'veer-theme-original-cart';
export const RATES_CACHE_KEY = 'veer-theme-estimated-delivery-rates-cache';
export const ZIP_CODE_KEY = 'veer-theme-saved-zip';
